import { useState } from "react";

export const useModal = () => {
  const [modal, setModal] = useState({
    deleteModal: false,
    restoreModal: false,
    deleteAllModal: false,
    restoreAllModal: false,
    type: "",
  });

  const handleOpenDeleteModal = () => {
    setModal({ ...modal, deleteModal: true });
  };
  const handleCloseDeleteModal = () => {
    setModal({ ...modal, deleteModal: false });
  };

  const handleOpenDeleteAllModal = () => {
    setModal({ ...modal, deleteAllModal: true });
  };
  const handleCloseDeleteAllModal = () => {
    setModal({ ...modal, deleteAllModal: false });
  };

  const handleOpenRestoreModal = () => {
    setModal({ ...modal, restoreModal: true });
  };
  const handleCloseRestoreModal = () => {
    setModal({ ...modal, restoreModal: false });
  };

  const handleOpenRestoreAllModal = () => {
    setModal({ ...modal, restoreAllModal: true });
  };
  const handleCloseRestoreAllModal = () => {
    setModal({ ...modal, restoreAllModal: false });
  };

  return {
    modal,

    handleOpenDeleteModal,
    handleCloseDeleteModal,

    handleOpenDeleteAllModal,
    handleCloseDeleteAllModal,

    handleOpenRestoreModal,
    handleCloseRestoreModal,

    handleOpenRestoreAllModal,
    handleCloseRestoreAllModal,
  };
};
